import { Modal } from "@mantine/core"
import { forwardRef, ForwardRefRenderFunction, useImperativeHandle, useRef } from "react"
import { SupplierSplitForm } from "../../components/supplier-split/split-form"
import { SupplierSalesList } from "../supplier-sales/list"
import { SupplierSalesListRef } from "../supplier-sales/list/types"

type SupplierSplitListProps = {
  action: any
  setSplitChecked: any
  splitChecked: any
  setAction: any
  success: any
}

export type SupplierSplitListRef = {
  getFilters: SupplierSalesListRef["getFilters"]
  getOrder: SupplierSalesListRef["getOrder"]
}

/**
 * «Хэсэгчлэн хүргэх» tab. It is the same table component as «Нийт захиалга» in `split` mode
 * (one set of columns, filters and row cells); this wrapper only owns the «Хуваарилах» dialog.
 */
const Component: ForwardRefRenderFunction<SupplierSplitListRef, SupplierSplitListProps> = (
  { action, setSplitChecked, splitChecked, setAction, success },
  ref,
) => {
  const listRef = useRef<SupplierSalesListRef>(null)

  useImperativeHandle(ref, () => ({
    getFilters: () => listRef.current!.getFilters(),
    getOrder: () => listRef.current!.getOrder(),
  }))

  return (
    <>
      <SupplierSalesList
        mode="split"
        ref={listRef}
        checked={splitChecked}
        setChecked={setSplitChecked}
        actions={[]}
        setActions={() => undefined}
      />
      <Modal opened={action[0] === "split"} onClose={() => setAction([])} withCloseButton={false} size="md" padding={0} radius="lg" centered>
        <SupplierSplitForm
          action={action}
          onCancel={() => setAction([])}
          reload={() => listRef.current?.reload()}
          setChecked={setSplitChecked}
          success={success}
        />
      </Modal>
    </>
  )
}

export const SupplierSplitList = forwardRef(Component)
